
import type { FC, ReactNode } from 'react';

import {
  Box,
  Container,
  Unstable_Grid2 as Grid,
  type ContainerProps,
  type Grid2Props,
  type SxProps,
} from '@mui/material';

import { useSettings } from '@/hooks/use-settings';

interface SubLayoutContainerProps {
  children?: ReactNode;
  gridProps?: Grid2Props;
  boxStyles?: SxProps;
  containerProps?: ContainerProps;
}

const SubLayoutContainer: FC<SubLayoutContainerProps> = (props) => {
  const { children, gridProps, boxStyles, containerProps } = props;
  const muiGridProps = {
    container: true,
    disableEqualOverflow: true,
    spacing: { xs: 3, lg: 4 },
    alignItems: 'center',
    ...gridProps,
  } as Grid2Props;
  const muiContainerProps = {
    maxWidth: (useSettings().stretch ? false : 'xl') as false | 'xl',
    disableGutters: true,
    ...containerProps,
  } as ContainerProps;

  return (
    <Box
      component="div"
      sx={{
        flexGrow: 1,
        my: 4,
        ...boxStyles,
      }}
    >
      <Container {...muiContainerProps}>
        <Grid {...muiGridProps}>{children}</Grid>
      </Container>
    </Box>
  );
};

export default SubLayoutContainer;
